import React from 'react';
import {Modal, View, Text, TouchableOpacity, ScrollView, useWindowDimensions} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import i18n from 'i18n-js';
import {fontFamily} from '../../helpers/fontFamily';
import {getCartLabel} from './cartRemovalPrompt';

export const getStatusChangeOutcome = result => ({
  totes: result?.data?.removed_totes || [],
  notChanged: result?.data?.not_changed || []
});

export const getStatusFailureMessage = result =>
  Array.isArray(result?.errorMessages) && result.errorMessages.length > 0
    ? result.errorMessages.join(' ')
    : i18n.t('order.statusUpdateFailed');

export const formatToteLine = row =>
  `Cart ${getCartLabel(row)}, tote ${row.tote_name}: order ${row.increment_id}`;

export const formatNotChanged = items =>
  `Status not changed for: ${items
    .map(item => `${item.increment_id} (${item.message})`)
    .join(', ')}`;

const textStyle = {color: '#000000', fontFamily: fontFamily.font300};

// onRequestClose is a no-op on purpose: Android back must not dismiss an acknowledge-only modal.
const AcknowledgeModal = ({title, lines, buttonText, buttonTestID, onAcknowledge}) => {
  const {width: screenWidth, height: screenHeight} = useWindowDimensions();
  const modalWidth = Math.min(screenWidth * 0.9, 500);
  return (
    <Modal
      visible
      transparent
      animationType="fade"
      onRequestClose={() => {}}>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0,0,0,0.5)'
        }}>
        <LinearGradient
          colors={['#FFB538', '#CF7C08']}
          start={{x: 0.5, y: 0}}
          end={{x: 0.5, y: 1}}
          style={{
            paddingVertical: 30,
            paddingHorizontal: 24,
            borderRadius: 15,
            alignItems: 'center',
            width: modalWidth,
            maxHeight: screenHeight * 0.85
          }}>
          <Text style={{...textStyle, fontSize: 24, marginBottom: 10, textAlign: 'center'}}>
            {title}
          </Text>
          <ScrollView style={{alignSelf: 'stretch', marginBottom: 20}}>
            {lines.map((line, index) => (
              <Text
                key={index}
                style={{...textStyle, fontSize: 18, marginBottom: 6, textAlign: 'center'}}>
                {line}
              </Text>
            ))}
          </ScrollView>
          <TouchableOpacity
            testID={buttonTestID}
            style={{
              paddingHorizontal: 10,
              paddingVertical: 3,
              borderRadius: 15,
              minWidth: 100,
              alignItems: 'center',
              borderWidth: 1,
              borderColor: '#000000'
            }}
            onPress={onAcknowledge}>
            <Text style={textStyle}>{buttonText}</Text>
          </TouchableOpacity>
        </LinearGradient>
      </View>
    </Modal>
  );
};

export const EmptyTotesModal = ({totes, onAcknowledge}) => (
  <AcknowledgeModal
    title="Empty these totes"
    lines={totes.map(formatToteLine)}
    buttonText="Totes emptied"
    buttonTestID="totesEmptiedBtn"
    onAcknowledge={onAcknowledge}
  />
);

export const StatusNotChangedModal = ({notChanged, onAcknowledge}) => (
  <AcknowledgeModal
    title="Status not changed"
    lines={[formatNotChanged(notChanged)]}
    buttonText="OK"
    buttonTestID="statusNotChangedOkBtn"
    onAcknowledge={onAcknowledge}
  />
);

export const StatusChangeOutcomeModal = ({outcome, onTotesAcknowledged, onNotChangedAcknowledged}) => {
  if (!outcome) return null;
  if (outcome.totes.length > 0) {
    return <EmptyTotesModal totes={outcome.totes} onAcknowledge={onTotesAcknowledged} />;
  }
  if (outcome.notChanged.length > 0) {
    return (
      <StatusNotChangedModal
        notChanged={outcome.notChanged}
        onAcknowledge={onNotChangedAcknowledged}
      />
    );
  }
  return null;
};
